import * as Yup from 'yup';
import { MESSAGE_INVALID_EMAIL, MESSAGE_REQUIRED } from '@/utils/validation-utils';

export const emailSchema: Yup.StringSchema = Yup.string()
  .required(MESSAGE_REQUIRED)
  .matches(/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,12}(?:\.[a-z]{2})?)$/, MESSAGE_INVALID_EMAIL);
//.email(MESSAGE_INVALID_EMAIL);
